// Cloudflare Turnstile configuration
// Uses environment variable from Cloudflare Pages
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '0x4AAAAAAB1ZVVE0nIXw47x_'

// For development, you can use a test key
export const TURNSTILE_SITE_KEY_DEV = '0x4AAAAAAB1ZVVE0nIXw47x_'
